module.exports = __webpack_public_path__ + "static/willow-square3-335f07269325f76f7f9be288413ccd03.jpg";